export default __webpack_public_path__ + "static/media/Deportivo_Alaves_logo_(2020).302ff7a6.svg";